export const AT_HINTS_SET = 'HINTS_HINTS_SET';
export const AT_HINT_SET = 'HINTS_HINT_SET';
export const AT_HINT_ACTION_SET = 'HINTS_HINT_ACTION_SET';
